import { Alert, Anchor, Button, Center, Group, Paper, PasswordInput, Stack, Text, ThemeIcon, Title } from '@mantine/core';
import { IconAlertTriangle, IconLeaf } from '@tabler/icons-react';
import { useQueryClient } from '@tanstack/react-query';
import { type FormEvent, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router';
import { api, errorText } from '../api';

const MIN = 10;

/** Link z e-maila („Nie pamiętasz hasła?”): nowe hasło, powtórzone, OK — potem logowanie nowym hasłem. */
export function ResetPasswordPage() {
  const [params] = useSearchParams();
  const token = params.get('token') ?? '';
  const navigate = useNavigate();
  const qc = useQueryClient();
  const [next, setNext] = useState('');
  const [repeat, setRepeat] = useState('');
  const [error, setError] = useState<string | null>(token ? null : 'Brak tokenu w linku — otwórz link z e-maila jeszcze raz albo poproś o nowy w oknie logowania.');
  const [busy, setBusy] = useState(false);

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    if (next.length < MIN) return setError(`Nowe hasło musi mieć co najmniej ${MIN} znaków`);
    if (next !== repeat) return setError('Hasła nie są takie same');
    setBusy(true);
    setError(null);
    try {
      await api('/auth/password-reset/confirm', { method: 'POST', body: { token, newPassword: next } });
      // wszystkie sesje konta zostały zakończone — logowanie nowym hasłem
      qc.setQueryData(['me'], null);
      navigate('/logowanie', { replace: true, state: { passwordReset: true } });
    } catch (err) {
      setError(errorText(err));
      setBusy(false);
    }
  };

  return (
    <Center mih="100vh" px="md" style={{ background: 'var(--app-bg)' }}>
      <Stack w="100%" maw={400} gap="lg">
        <Group gap="sm">
          <ThemeIcon size={40} radius="md" variant="gradient" gradient={{ from: 'eko.6', to: 'teal.8', deg: 135 }}>
            <IconLeaf size={22} />
          </ThemeIcon>
          <Text fw={800} size="lg">
            Eko CRM
          </Text>
        </Group>
        <div>
          <Title order={2}>Ustaw nowe hasło</Title>
          <Text c="dimmed" size="sm">
            Nowe hasło: co najmniej {MIN} znaków.
          </Text>
        </div>
        <Paper withBorder shadow="sm" p="xl">
          <form onSubmit={submit} noValidate>
            <Stack>
              {error && (
                <Alert color="red" icon={<IconAlertTriangle />}>
                  {error}
                </Alert>
              )}
              <PasswordInput label="Nowe hasło" autoComplete="new-password" value={next} onChange={(e) => setNext(e.currentTarget.value)} required autoFocus size="md" disabled={!token} />
              <PasswordInput label="Powtórz nowe hasło" autoComplete="new-password" value={repeat} onChange={(e) => setRepeat(e.currentTarget.value)} required size="md" disabled={!token} />
              <Button type="submit" size="md" fullWidth loading={busy} disabled={!token}>
                OK
              </Button>
            </Stack>
          </form>
        </Paper>
        <Text size="sm" ta="center">
          <Anchor href="/logowanie">Wróć do logowania</Anchor>
        </Text>
      </Stack>
    </Center>
  );
}
